<template>
  <div class="btn-group btn-group-sm">
    <!-- <button v-if="can_access('marketvalue','modify')" class="btn btn-edit" title="Edit Currency" @click="showModal('edit')"><i class="fa fa-edit"></i></button> -->
    <!-- <button v-if="can_access('marketvalue','modify')" class="btn btn-gray" title="Copy Currency" @click="showModal('copy')"><i class="fa fa-copy"></i></button> -->
    <button v-if="can_access('marketvalue','modify')" class="btn btn-danger" title="Delete Currency" @click="showModal('delete')"><i class="fa fa-trash"></i></button>
  </div>
</template>
<script>
import $ from 'jquery';
import common from '@/assets/js/common.js';
export default {
  props: ['row', 'nested','refresh'],
  mixins: [common],
  data(){
    return {
      show: 1,
      rowData:{},
      action:''
    }
  },
  components: { },
  mounted () {
    //$(this.$el).find('button[title]').tooltip()
  },
  computed: {
    isDisplayRowVisible () {
      //if (this.nested.comp !== 'SubTrades') return
      return this.nested.visible
    },
  },
  methods: {
    toggleNestedComp (comp) {
      const { nested } = this
      if (nested.comp === comp) return nested.$toggle()
      nested.$toggle(comp, true)
    },
    async showModal(action) {
        this.action = action;
        if(action=='edit'){
            this.rowData = this.duplicate(this.row);
            this.rowData.action = 'edit'
        }
        else if(action=='delete'){
          if(confirm("Do you really want to delete?")){
            this.rowData = this.duplicate(this.row);
            this.rowData.status = 0;
            await this.call_axios('default_margin_rate', 'post', this.rowData);
            this.refresh();
          }else return;
        }
        else if(action=='copy'){
          this.rowData = this.duplicate(this.row);
          this.rowData.action = 'create'
          this.rowData.id = '';
        }
        //this.$refs['edit-cur-out'].show()
    },
  }
}
</script>
<style>
.-nested-comp-open-btn {
  color: #fff !important;
  background-color: #337ab7 !important;
}
dd, dt {
    line-height: 1.42857143;
}
</style>
